/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAlertEvents,
    InternalApiAlertEventsFromJSON,
    InternalApiAlertEventsToJSON,
    InternalApiAlertType,
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeToJSON,
} from '../models';

export interface GetAlertEventsRequest {
    alertId: number;
    alertType: InternalApiAlertType;
}

/**
 * 
 */
export class AlertEventInternalApi extends runtime.BaseAPI {

    /**
     * Get events for alert
     */
    async getAlertEventsRaw(requestParameters: GetAlertEventsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertEvents>> {
        if (requestParameters.alertId === null || requestParameters.alertId === undefined) {
            throw new runtime.RequiredError('alertId','Required parameter requestParameters.alertId was null or undefined when calling getAlertEvents.');
        }

        if (requestParameters.alertType === null || requestParameters.alertType === undefined) {
            throw new runtime.RequiredError('alertType','Required parameter requestParameters.alertType was null or undefined when calling getAlertEvents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/{alertType}/{alertId}/events`.replace(`{${"alertId"}}`, encodeURIComponent(String(requestParameters.alertId))).replace(`{${"alertType"}}`, encodeURIComponent(String(requestParameters.alertType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertEventsFromJSON(jsonValue));
    }

    /**
     * Get events for alert
     */
    async getAlertEvents(requestParameters: GetAlertEventsRequest, initOverrides?: RequestInit): Promise<InternalApiAlertEvents> {
        const response = await this.getAlertEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
